<template>
    <AlbumForm :album="album" style="width: 560px;" v-on="$listeners"/>
</template>

<script>
    import AlbumForm from "../comps/AlbumForm";

    export default {
        name: "Info",
        components: {AlbumForm},
        props: {album: Object},
    }
</script>
